import { useTranslations } from 'next-intl';
import React from 'react';
import type { ReactNode } from 'react';

type Props = {
  children?: React.ReactNode;
  title: React.ReactNode;
};

export default function PageLayout({ children, title }: Props) {
  const t = useTranslations('PageLayout');

  return (
    <div className="font-inter">
      <div className="grid min-h-[calc(100vh-10rem)] lg:min-h-[830px] grid-cols-4 lg:grid-cols-9 grid-rows-8 gap-4">
        {children}
      </div>
    </div>
  );
}
